import React, { useCallback } from 'react';
import cl from 'classnames';

import { IconsEnum } from '../../../../../../../assets/icons/types';

import { ButtonHelper } from '../../../../../../../helpers/buttons/ButtonHelper';
import { Icon } from '../../../../../../../helpers/Icon';
import { Translate } from '../../../../../../../helpers/Translate';

import { categoriesKeys } from '../../../../../../../locales/keys';
import { IsDisabled } from '../../../../../../../types';

interface ThreeDStockMenuCategoriesItemAmountButtonProps {
  showAll: boolean;
  setShowAll: (val: boolean) => void;
  disabled?: IsDisabled;
}

function ThreeDStockMenuCategoriesItemAmountButton({
  showAll,
  setShowAll,
  disabled
}: ThreeDStockMenuCategoriesItemAmountButtonProps) {
  const handleShowAll = useCallback(() => {
    setShowAll(true);
  }, [setShowAll]);

  const handleHide = useCallback(() => {
    setShowAll(false);
  }, [setShowAll]);

  return (
    <ButtonHelper
      className="flex w-full items-center gap-1 px-4 py-1.5 rounded-lg text-gray-500 dark:text-gray-400 hover:text-current dark:hover:text-current hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors duration-150 ease-out"
      dataGa={`3d-stock-menu-products-categories-${
        showAll ? 'seeLess' : 'seeAll'
      }`}
      onClick={showAll ? handleHide : handleShowAll}
      disabled={disabled}
    >
      <span className="text-md leading-6 underline">
        <Translate
          id={showAll ? categoriesKeys.seeLess : categoriesKeys.seeAll}
        />
      </span>
      <Icon
        icon={IconsEnum.ARROW_DOWN_TRIANGLE_SOLID}
        className={cl('h-4 w-4', showAll ? 'transform rotate-180' : null)}
      />
    </ButtonHelper>
  );
}

export default ThreeDStockMenuCategoriesItemAmountButton;
